import React, { useRef, useEffect, useState } from 'react';
import { connect, useDispatch } from 'react-redux';
import PlusIcon from "../../images/plus-rounded.svg";
import MinusIcon from "../../images/minus-red.svg";
import { AISearchResponse, updateAISearchResponse } from '../../services/actions/actions';
import DraftEditor from './DraftEditor';
import { useResume } from '../../context/ResumeContext';
import PageLoader from './PageLoader';
import { stripTags } from '../../helper';
import { POPUP_TYPES } from '../../constants/constants';
import { usePopup } from '../../context/PopupContext';

const GPTSuggestionPopup = (props) => {
    const dispatch = useDispatch();
    const popupbox = usePopup();
    const [phrase, setPhrase] = useState(props.phrase);
    const [showResult, setShowResult] = useState(false);
    const [showLoader, setShowLoader] = useState(false);
    const [aidataExists, setAiDataExists] = useState(false);
    const aidata = props.aidata;
    const {
        resume: {
            heading,
            summary,
            work_history,
            enabled_tabs,
            skipped_sections
        },
        handlers: {
            updateResumePreview,
            nuteralizeNextClick,
            nuteralizeBackClick
        },
        next_clicked,
        next_label,
        back_clicked,
        skip_clicked,
        toggleSkip
    } = useResume();
    
    const [aisearchValue, setAisearchValue] = useState('');
    let [rbAiSummary, setRbAiSummary] = useState('');

    useEffect(() => {
        popupbox.configurePopup(POPUP_TYPES)
    }, []);

    const AISearchTitlePopupHandler = () => {
        popupbox.show('ai_entity_title', null, aiSearchPopupCloseHandler, {
            title: phrase,
            section: props.section,
            setShowAIPopup: (s) => props.setShowAIPopup(s)
        })
    }

    const aiSearchPopupCloseHandler = (params) => {
        updateAiSearchString(params.phrase)
        setShowResult(!showResult)
        setPhrase(params.phrase)
        setAiDataExists(true)
    }

    useEffect(() => {
        AISearchTitlePopupHandler()
    }, []);

    const editorContent = () => {
        switch(props.section){
            case 'heading':
                return summary.content;
            case 'profession':
            case 'education':
                return props.data.description;
            case 'custom':
                return props.data.content;
            default:
                //do nothing..
                break;
        }
    }
    const EditorPopUpLabel = () => {
        switch(props.section){
            case 'heading':
            case 'profession':
            case 'custom':
                return (<>
                    <span>Use our AI to help you write this section. Enter a job title below, and suggestions will be automatically generated.</span>
                </>)
            case 'education':
                return (<>
                    <span>Use our AI to help you write this section. Enter a field of study below, and suggestions will be automatically generated.</span>
                </>)
            default:
                return (<>
                    <span>Use our AI to help you write this section. Enter a job title below, and suggestions will be automatically generated.</span>
                </>)
        }
    }
    
    const updateAiSearchString = (phrase) => {
        setAisearchValue(phrase);
    }

    const phraseClickHandler = (aicontent, clickedItem = 'plus') => {
        // for the heading section, use <p> tag otherwise <li> -- RBAPP #569
        const aicontent2 = (props.section == 'heading' ? `<p>${aicontent}</p>` : `<li>${aicontent}</li>`);

        for(let i = 0; i < aidata.length; i++){
            if(clickedItem == 'plus' && aidata[i].content == aicontent){
                aidata[i].plusIcon = 'no';
                aidata[i].minusIcon = 'yes';
            } else if(clickedItem == 'minus' && aidata[i].content == aicontent){
                aidata[i].plusIcon = 'yes';
                aidata[i].minusIcon = 'no';
            }
        }

        if (clickedItem == 'plus') {
            switch(props.section){
                case 'heading':
                    //summary.content = stripTags(summary.content, ['ul']); //commented for the tickets #569 and #600
                    summary.content = summary.content
                    .replace(/<li><br><\/li>/g, '')
                    .replace(/<li><\/li>/g, '')
                    .replace(/<p><br><\/p>/g, '')
                    .replace(/<p><\/p>/g, '');
                    summary.content += aicontent2;
                    //summary.content = `<ul>${summary.content}</ul>`; //commented for the tickets #569 and #600
                    /**
                     * START
                     * Append the <li> content according to <ol> and <ul>
                     * Ticket ID: https://gitlab.dailyrssmail.com/growthlabs/resumebuilder-app/-/issues/600
                     * Date: 2024-01-18
                     */
                    // if(summary.content.slice(-5) == '</ol>')
                    //     summary.content = summary.content.replace(/<\/ol>$/, `${aicontent2}</ol>`);
                    // else if(summary.content.slice(-5) == '</ul>')
                    //     summary.content = summary.content.replace(/<\/ul>$/, `${aicontent2}</ul>`);
                    // else 
                    //     summary.content += aicontent2;
                    /**
                     * END
                     */
                    props.updateAction({ summary: summary, current_tab: 'summary' });
                    break;
                case 'profession':
                case 'education':
                    // props.data.description = stripTags(props.data.description, ['ul']); //commented for ticket #600
                    props.data.description = props.data.description
                    .replace(/<li><br><\/li>/g, '')
                    .replace(/<li><\/li>/g, '')
                    .replace(/<p><br><\/p>/g, '')
                    .replace(/<p><\/p>/g, '');
                    //props.data.description += aicontent2; //commented for ticket #600
                    //props.data.description = `<ul>${props.data.description}</ul>`; //commented for ticket #600
                    /**
                     * START
                     * Append the <li> content according to <ol> and <ul>
                     * Ticket ID: https://gitlab.dailyrssmail.com/growthlabs/resumebuilder-app/-/issues/600
                     * Date: 2024-01-18
                     */
                    if(props.data.description.slice(-5) == '</ol>'){
                        props.data.description = props.data.description.replace(/<\/ol>$/, `${aicontent2}</ol>`);
                        props.data.description = stripTags(props.data.description, ['ol']); // changes for #974
                        props.data.description = `<ol>${props.data.description}</ol>`; // changes for #974
                    }else if(props.data.description.slice(-5) == '</ul>'){
                        props.data.description = props.data.description.replace(/<\/ul>$/, `${aicontent2}</ul>`);
                        props.data.description = stripTags(props.data.description, ['ul']); // changes for #974
                        props.data.description = `<ul>${props.data.description}</ul>`; // changes for #974
                    }else{
                        props.data.description += aicontent2;
                        props.data.description = stripTags(props.data.description, ['ul']); // changes for #974
                        props.data.description = `<ul>${props.data.description}</ul>`; // changes for #974
                    }
                    /**
                     * END
                     */
                    props.updateAction({ description: props.data.description }, props.id);
                    break;
                case 'custom':
                    props.data.content += aicontent2;
                    props.updateAction({ content: props.data.content }, props.id);
                    break;
                default:
                    //do nothing..
                    break;
            }
            rbAiSummary += aicontent2;
        } else if(clickedItem == 'minus'){
            switch(props.section){
                case 'heading':
                    summary.content = summary.content
                    .replace(aicontent, '')
                    .replace(/<li><\/li>/g, '')
                    .replace(/<p><\/p>/g, '');
                    props.updateAction({ summary: summary, current_tab: 'summary' });
                    break;
                case 'profession':
                case 'education':
                    props.data.description = props.data.description
                    .replace(aicontent, '')
                    .replace(/<li><\/li>/g, '')
                    .replace(/<p><\/p>/g, '');
                    props.updateAction({ description: props.data.description }, props.id);
                    break;
                default:
                    //do nothing..
                    break;
            }
            rbAiSummary = rbAiSummary.replace(aicontent, '');
        }

        setRbAiSummary(rbAiSummary);
        dispatch(updateAISearchResponse(aidata));
    }

    const searchClickHandler = () => {
        setAiDataExists(false);
        setShowLoader(true);
        dispatch(AISearchResponse(props.section, aisearchValue)).then(res => {
            if(res.aidata.length){
                setAiDataExists(true);
                setShowLoader(false);
            }
        }).catch(error => {
            console.log(error);
        });
    }

    const updateRbAiValue = (val) => {
        switch(props.section){
            case 'heading':
                props.updateAction({ summary: { content: val }, current_tab: 'summary' });
                break;
            case 'profession':
            case 'education':
                //let description = props.jopb.description;
                props.updateAction({ description: val }, props.id);
                break;
            default:
                //do nothing..
                break;
        }
        setRbAiSummary(val);
    }

    const enter = (e) => {
        if(e.key === 'Enter'){
            e.preventDefault();
            e.stopPropagation();
            setShowLoader(true);
            searchClickHandler();
        }
    }
    const handleActiveState = (callback) => {
        if(typeof callback == 'function'){
          setTimeout(function(){          
            callback();
          },20);
          
        }
      }
    const ref2 = useRef(null);
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (ref2.current && !ref2.current.contains(event.target)) {
                props.setShowAIPopup(false);
                let btns = document.querySelectorAll('.rb-ai-wrap .rb-ai');
                btns.length && btns.forEach(function(curr,index,btns){
                    btns[index].classList.remove('active');
                });
            }
        };
        document.addEventListener('click', handleClickOutside, true);
        return () => {
            document.removeEventListener('click', handleClickOutside, true);
        };
    });

    return (showResult && <div className="rb-ai-popup" ref={ref2}>
        <div className="rb-ai-result">
            <div className="close-it">
                <span className="close" 
                    onClick={() => {
                        props.setShowAIPopup(false);
                        handleActiveState(function(){
                            let btns = document.querySelectorAll('.rb-ai-wrap .rb-ai');
                            btns.length && btns.forEach(function(curr,index,btns){
                                btns[index].classList.remove('active');
                            });                    
                          }); 
                    }}>
                        <i className="icon-cross-icon"></i>
                </span>
            </div>
           <div className="rb-ai-blocks">
                <div className="left-block">
                     <label className="popup-label">
                        <EditorPopUpLabel />
                     </label>
                    <div className="field-wrap field-wrap-ai-search">
                        <input 
                            type="text" 
                            name="ai-search" 
                            defaultValue={phrase ?? aisearchValue} 
                            onChange={(e) => updateAiSearchString(e.target.value)} 
                            onKeyDown={e => enter(e)}/>
                        <span className="search" onClick={searchClickHandler}><i className="icon-search-icon"></i></span>
                    </div>
                    <div className="result-list-wrap">
                        <div className="result-list">
                            {aidataExists ? (<ul>
                                {
                                    aidata.map((v, k) => {
                                        return (<li onClick={() => phraseClickHandler(v.content, (v.plusIcon == 'yes' ? "plus" : 'minus'))} key={`aidata-${k}`}>
                                            <div className={"sign" + (v.featured == 'no' ? ' no-star' : '')}>
                                                <span className={(v.plusIcon == 'yes' ? "plus-sign" : (v.minusIcon == 'yes' ? "minus-sign" : ''))}>
                                                    {(v.plusIcon == 'yes' ? <PlusIcon /> : (v.minusIcon == 'yes' ? <MinusIcon /> : ''))}
                                                </span>
                                                {(v.featured == 'yes' ? <i className="icon-star-icon"></i> : '')}
                                            </div>
                                            <div className="point">
                                                <span>{(v.recommendation == 'yes' ? "Recommendation" : "")}</span>
                                                <p>{v.content}</p>
                                            </div>
                                        </li>);
                                    })
                                }
                            </ul>) : (showLoader ? <PageLoader /> : '')}
                        </div>
                    </div>
                </div>
                <div className="right-block">
                    <div className="ai-editor_wrap">
                        <DraftEditor 
                            name="description"
                            className="validate"
                            textAlignment='left'
                            value={editorContent()} 
                            onInputChange={(val) => {
                                updateRbAiValue(val);
                            }}
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>);
}

export default connect(state => state)(GPTSuggestionPopup);